// extracted by mini-css-extract-plugin
export default {"container":"TableWeightCell_container__Q3Mgo"};